(() => {
  const filters = document.querySelector('.products-category');
  const productsList = document.querySelector('.section--products-page .products-list');

  if (!filters || !productsList) {
    return;
  }

  let requestController;

  function setActiveFilter(targetUrl) {
    const url = new URL(targetUrl, window.location.href);
    const collectionUrl = new URL(filters.dataset.collectionUrl, window.location.origin);
    const collectionPath = collectionUrl.pathname.replace(/\/+$/, '');
    const targetPath = url.pathname.replace(/\/+$/, '');
    const selectedTag = targetPath.startsWith(`${collectionPath}/`)
      ? decodeURIComponent(targetPath.slice(collectionPath.length + 1).split('/')[0])
      : '';
    const filterItems = [...filters.querySelectorAll('.products-category__item')];
    const activeItem = filterItems.find((item) => item.dataset.filterTag === selectedTag)
      || filterItems.find((item) => item.dataset.filterTag === '');

    filterItems.forEach((item) => {
      const isActive = item === activeItem;
      const itemTag = item.dataset.filterTag;
      const itemUrl = new URL(collectionUrl);

      if (itemTag) {
        itemUrl.pathname = `${collectionPath}/${encodeURIComponent(itemTag)}`;
      }

      item.classList.toggle('active', isActive);
      item.href = isActive && itemTag ? collectionUrl.href : itemUrl.href;

      if (isActive) {
        item.setAttribute('aria-current', 'page');
      } else {
        item.removeAttribute('aria-current');
      }
    });
  }

  function initProductForms(container) {
    if (typeof window.addToCart !== 'function') {
      return;
    }

    container.querySelectorAll('.js-product-form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const button = form.querySelector('button[type="submit"]');
        window.addToCart(new FormData(form), button);
      });
    });
  }

  function waitForNextPaint() {
    return new Promise((resolve) => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });
  }

  async function loadProducts(targetUrl, updateHistory = true) {
    requestController?.abort();
    const controller = new AbortController();
    requestController = controller;

    const url = new URL(targetUrl, window.location.href);
    url.searchParams.delete('section_id');
    setActiveFilter(url);

    const sectionUrl = new URL(url);
    sectionUrl.searchParams.set('section_id', 'collection');

    filters.classList.add('is-loading');
    productsList.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(sectionUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`Unable to load products: ${response.status}`);
      }

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextProductsList = nextDocument.querySelector('.products-list');

      if (!nextProductsList) {
        throw new Error('The filtered collection markup is incomplete');
      }

      productsList.innerHTML = nextProductsList.innerHTML;
      initProductForms(productsList);

      if (updateHistory) {
        window.history.pushState({}, '', url);
      }

      await waitForNextPaint();

      if (controller.signal.aborted) {
        return;
      }

    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }

      window.location.assign(url.href);
    } finally {
      if (requestController === controller) {
        filters.classList.remove('is-loading');
        productsList.removeAttribute('aria-busy');
      }
    }
  }

  filters.addEventListener('click', (event) => {
    const link = event.target.closest('.products-category__item');

    if (
      !link
      || event.defaultPrevented
      || event.button !== 0
      || event.metaKey
      || event.ctrlKey
      || event.shiftKey
      || event.altKey
    ) {
      return;
    }

    event.preventDefault();
    loadProducts(link.href);
  });

  window.addEventListener('popstate', () => {
    loadProducts(window.location.href, false);
  });
})();
